import SOFTSKILLS from 'data/mantechcar24/soft-skills.json';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const SoftSkillsCommunityVsOffered: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');
  const { locale } = useRouter();

  return (
    <div>
      <StyledRecharts className="skills">
        <ResponsiveContainer width="99%" height={950} minWidth={500}>
          <BarChart data={SOFTSKILLS} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey={(data) => data.skill[locale || 'en']}
              tickLine={false}
              width={200}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number, name: string) => [
                value.toFixed(1) + '%',
                name
              ]}
              wrapperClassName="tooltip-y"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: 0 }}
            />
            <Bar
              dataKey="offers"
              name={t('mantechcar24.talent.competences.companies')}
              fill="#7EAFD3"
              barSize={8}
              radius={5}
            />
            <Bar
              dataKey="users"
              name={t('mantechcar24.talent.competences.community')}
              fill="#8DD3C7"
              barSize={8}
              radius={5}
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default SoftSkillsCommunityVsOffered;
